import React from 'react';
import { useSelector } from 'react-redux';
import { usePermission, useAnyPermission, useRole } from '../hooks/useAuth';
import { selectPermissions } from '../store/authSlice';

const PermissionGuard = ({ 
  children, 
  permission = null, 
  permissions = [], 
  requireAll = false,
  role = null,
  allowSuperAdmin = false, // Deprecated: no longer used
  fallback = null 
}) => {
  const hasPermission = usePermission(permission);
  const hasAnyPermission = useAnyPermission(permissions);
  const hasRole = useRole(role);
  const userPermissions = useSelector(selectPermissions);

  // Role check - strictly permission-based
  if (role && !hasRole) {
    return fallback;
  }

  // Single permission check - strictly permission-based
  if (permission && !hasPermission) {
    return fallback;
  }

  // Multiple permissions check - strictly permission-based
  if (permissions.length > 0) {
    if (requireAll) {
      // Check if user has ALL permissions
      const hasAllPermissions = permissions.every(perm => 
        userPermissions.some(userPerm => userPerm.name === perm)
      );
      if (!hasAllPermissions) {
        return fallback;
      }
    } else {
      // Check if user has ANY permission
      if (!hasAnyPermission) {
        return fallback;
      }
    }
  }

  return children;
};

export default PermissionGuard; 